export enum SelectSearch {
  DatabaseAdd = 'DATABASE',
  GoogleResults = 'GOOGLEADDRESS',
}
